import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import ProgressIndicator from './progress-indicator';

const { Heading, ActionButton, Paragraph, Box } = designSystem;

function LimitBanner({
  current,
  total,
  onButtonClick,
  captions,
  withUpgrade = true,
  withProgressBar = true,
}) {
  return (
    <div className="ws-limit-banner">
      <div className="ws-limit-banner__container">
        <div className="ws-limit-banner__info">
          <Heading type="heading-6" weight="regular" singleLine>
            {captions.title}
          </Heading>
          <Paragraph appearance="medium-emphasis">
            {current}/{total}
          </Paragraph>
        </div>
        {withUpgrade && (
          <div className="ws-limit-banner__button-container">
            <ActionButton
              format="text"
              appearance="cta"
              onClick={onButtonClick}
              label={captions.buttonText}
            />
          </div>
        )}
      </div>
      {withProgressBar && (
        <Box marginTop="spacing-3-xs">
          <ProgressIndicator total={total} current={current} />
        </Box>
      )}
    </div>
  );
}

LimitBanner.propTypes = {
  current: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  onButtonClick: PropTypes.func.isRequired,
  captions: PropTypes.shape({
    title: PropTypes.string,
    buttonText: PropTypes.string,
  }).isRequired,
  withProgressBar: PropTypes.bool,
  withUpgrade: PropTypes.bool,
};

export default LimitBanner;
